import React from 'react';
import { Route as RouteDom } from 'react-router-dom';
import { PrivateRoute } from 'components/Atoms';

import privateRoutes from './private';
import publicRoutes from './public';
import { checkValidRole } from 'utilities/common';

const renderRoutes = (isPrivate = false, userInfo) => {
  let routes = publicRoutes;
  let Route = RouteDom;

  if (isPrivate) {
    routes = privateRoutes;
    Route = PrivateRoute;
  }
  return routes.map(
    (
      {
        component: Component,
        roles,
        condition,
        defaultShow = false,
        mobile,
        path,
        exact,
        ...rest
      },
      idx
    ) => {
      return (
        checkValidRole({
          userInfo,
          roles,
          condition,
          isPrivate,
          defaultShow,
          mobile,
        }) && (
          <Route
            exact={exact}
            path={
              path.includes(':accountType')
                ? path.replace(':accountType', userInfo.role)
                : path
            }
            {...rest}
            key={idx}
          >
            <Component exact={exact} path={path} {...rest} />
          </Route>
        )
      );
    }
  );
};

export default renderRoutes;
